import React, { useState } from "react"
import OutOfStockIcon from "../../assets/icons/out-of-stock.png"
import CalcPercentage from "../../utils/discountPercentage"
import { isAuthenticated } from "../../pages/login/auth/auth";
import axios from "axios"
import loadingGif from "../../assets/icons/loading.gif"
import { Link } from "react-router-dom"
import { API } from "../../Api";
import swal from "sweetalert";

export default function ProductCardSmall(props) {
  const [add, setAdd] = useState(false)
  const [loading, setLoading] = useState(false)
  const quantity = 1

  const handleAddToCart = () => {
    setLoading(true)
    //  Handle add to cart functionality goes here
    const { token, data } = isAuthenticated();


    if (isAuthenticated()) {
      axios({
        method: "post",
        url: `${API}cart`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          user_id: data.user.number,
          product_id: props.id,
          quantity: quantity,
          name: props.name,
          veg: props.veg,
          mrp: props.mrp,
          sellingPrice: props.sellingPrice,
          coverImage: props.coverImage,
          unit: props.unit,
          packaged: props.packaged,
        },
        validateStatus: (status) => {
          return true; //status === 201 || status === 200;
        },
      }).then((res) => {
        setLoading(false)
        setAdd(true);
      });
    } else {
      if (!localStorage.getItem("cart")) {
        const cartItemDetail = [
          {
            product_id: props.id,
            quantity: quantity,
            name: props.name,
            veg: props.veg,
            mrp: props.mrp,
            sellingPrice: props.sellingPrice,
            coverImage: props.coverImage,
            unit: props.unit,
            packaged: props.packaged,
          },
        ];
        localStorage.setItem("cart", JSON.stringify(cartItemDetail));
        // EncryptCartData(cartItemDetail);
        setLoading(false)
        setAdd(true);
      } else {
        const cartArr = JSON.parse(localStorage.getItem("cart"));
        // const cartArr = DecryptCartData();
        const newCartItem = {
          product_id: props.id,
          quantity: quantity,
          name: props.name,
          veg: props.veg,
          mrp: props.mrp,
          sellingPrice: props.sellingPrice,
          coverImage: props.coverImage,
          unit: props.unit,
          packaged: props.packaged,
        };
        cartArr.push(newCartItem);
        localStorage.setItem("cart", JSON.stringify(cartArr));
        // EncryptCartData(cartArr);
        setLoading(false)
        setAdd(true);
      }
    }
  };

  const percentage = CalcPercentage(props.mrp, props.sellingPrice)

  return (
    <div className="product-card-small border-box bg-white">
      <div
        className={`discount-box ${
          props.mrp == props.sellingPrice && "d-hidden"
        }`}
      >
        <code>{percentage}% OFF</code>
      </div>
      <Link to={`/product-details/${props.id}`}>
        <div className="product-card-small-image">
          <img
            src={`https://sbg-product-img.s3-us-west-1.amazonaws.com/${props.coverImage}`}
            alt={`${props.name} image`}
          />
        </div>
      </Link>
      <div className="product-card-small-details">
        <Link to={`/product-details/${props.id}`}>
          <div className="product-name">
            <h3>{props.name}</h3>
          </div>
        </Link>
        <div className="price-and-btn">
          <div className="price">
            <h2>
              ₹{props.sellingPrice}
              {!props.packaged && <h2>/{props.unit}</h2>}
            </h2>
            {props.sellingPrice != props.mrp && (
              <code>
                <s>
                  ₹{props.mrp}
                  {!props.packaged && <>/{props.unit}</>}
                </s>
              </code>
            )}
          </div>
          {props.stock ? (
            !add ? (
              loading ? (
                <img
                  src={loadingGif}
                  alt="loading-gif"
                  style={{ width: "40px" }}
                />
              ) : (
                <div className="add-to-cart btn" onClick={handleAddToCart}>
                  <ion-icon name="add"></ion-icon>
                </div>
              )
            ) : (
              <div className="add-to-cart btn">
                <ion-icon name="checkmark"></ion-icon>
              </div>
            )
          ) : (
            <img
              src={OutOfStockIcon}
              alt="out-of-stock-icon"
              style={{ width: "50px" }}
            />
          )}
        </div>
      </div>
    </div>
  )
}
